module.exports = "/images/joyride-note.png";